<template>
  <div>
    <h3 class="title">Datacasting</h3>
    <div class="line"></div>
    <Menu class="menu" :default-active="$route.path">
      <MenuItem index="/dashboard" class="itens">
        <router-link to="/dashboard" class="link">
          <font-awesome-icon :icon="['fas', 'chart-line']" class="icon" />
          Dashboard
        </router-link>
      </MenuItem>
      <MenuItem index="/schedule" class="itens">
        <router-link to="/schedule" class="link">
          <font-awesome-icon :icon="['fas', 'list']" class="icon" />
          Agendamentos
        </router-link>
      </MenuItem>
      <MenuItem index="/return-channel" class="itens">
        <router-link to="/return-channel" class="link">
          <font-awesome-icon :icon="['fas', 'circle-check']" class="icon" />
          Confirmação
        </router-link>
      </MenuItem>
      <MenuItem index="/devices" class="itens">
        <router-link to="/devices" class="link">
          <font-awesome-icon :icon="['fas', 'satellite-dish']" class="icon" />
          Dispositivos
        </router-link>
      </MenuItem>
      <MenuItem index="/settings" class="itens">
        <router-link to="/settings" class="link">
          <font-awesome-icon :icon="['fas', 'gear']" class="icon" />
          Configurações
        </router-link>
      </MenuItem>
    </Menu>
  </div>
</template>

<script>
import { ElMenu as Menu, ElMenuItem as MenuItem } from "element-plus";

export default {
  name: "NavBar",
  components: { Menu, MenuItem },
};
</script>

<style scoped>
.title {
  font-family: "Globo-Bold", sans-serif;
  font-size: 25px;
  line-height: 64px;
  height: 64px;
  margin: 0;
  padding: 0 18px;
  color: #f5f7f8;
  text-align: center;
}
.line {
  border-bottom: 1px solid #d2e0fb;
  margin: 0;
}
.el-menu {
  border: none;
}
.menu {
  background-color: #001f3f;
}
.itens {
  margin: 15px;
}
.link {
  text-decoration: none;
  color: inherit;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.icon {
  margin-right: 15px;
  font-size: 25px;
}
.el-menu-item {
  font-family: "Globo-Regular", sans-serif;
  font-size: 20px;
  color: #b7b7b7;
}
.el-menu-item.is-active {
  color: #3abef9;
  background-color: #001f3f;
}
.el-menu-item:hover {
  background-color: #001f3f;
  color: #f5f7f8;
}
</style>
